/**
 * Custom event facade — use for events autocapture can't express
 * (multi-step outcomes, business milestones).
 *
 *   trackEvent('buy_insurance_clicked', { type: 'VMI' });
 *
 * Naming: snake_case verbs in past tense (thing_happened). Keep properties
 * flat and primitive. No-ops when analytics is off (no key / test user).
 */
import posthog from 'posthog-js';

import { isAnalyticsEnabled } from './posthog';

export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  if (!isAnalyticsEnabled()) return;
  posthog.capture(name, properties);
}
